var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path6, _path7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path8, _g, _rect18, _rect19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 175,
    viewBox: "0 0 115 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1358_1488)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 169.911H4.83887V175H110V169.911Z",
    fill: "#E6D113"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 0H4.83887V5.08877H110V0Z",
    fill: "#E6D113"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83871 5.08887H0V169.965H4.83871V5.08887Z",
    fill: "#E6D113"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.054 5.08887H110V169.965H115.054V5.08887Z",
    fill: "#E6D113"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110 10H9V170H110V10Z",
    fill: "#FFEECE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 64,
    width: 11,
    height: 44,
    fill: "#FCED70"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 10,
    width: 7,
    height: 160,
    fill: "#FEF392"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 163,
    width: 101,
    height: 7,
    fill: "#FEF392"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 64,
    width: 11,
    height: 18,
    fill: "#E6D113"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 24,
    width: 62,
    height: 54,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 22,
    width: 62,
    height: 4,
    fill: "#EEDB31"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 78,
    width: 62,
    height: 4,
    fill: "#FCEE70"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78V26H92V78H88Z",
    fill: "#EEDB31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 78L22 26H26L26 78H22Z",
    fill: "#FCEE70"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 62,
    height: 11,
    fill: "#EFEFEF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 75,
    width: 62,
    height: 3,
    fill: "#EFEFEF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 88,
    width: 3,
    height: 3,
    fill: "#EEDB31"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 78,
    width: 4,
    height: 3,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 78,
    width: 7,
    height: 3,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 88,
    width: 3,
    height: 3,
    fill: "#EEDB31"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 88,
    width: 3,
    height: 3,
    fill: "#EEDB31"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 118,
    width: 5,
    height: 5,
    fill: "#FFF7AC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 123,
    width: 5,
    height: 5,
    fill: "#FFF7AC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 128,
    width: 5,
    height: 5,
    fill: "#FFF7AC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1358_1488",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 141,
    width: 59,
    height: 15
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8656 143.933H30.9328V141.056H28V155.726H30.9328V146.869H33.8656V143.936V143.933ZM33.8656 149.857H36.7984V146.924H33.8656V149.857ZM39.7343 143.933H36.8015V146.866H39.7343V155.723H42.6672V141.053H39.7343V143.93V143.933ZM47.8267 141.056H44.8939V155.726H47.8267V149.802H50.7595V155.726H53.6923V141.056H47.8236H47.8267ZM50.7595 146.869H47.8267V143.992H50.7595V146.869ZM56.0274 155.67H58.9602V141H56.0274V155.67ZM67.2415 143.88H64.3086V141.003H61.3758V155.673H64.3086V146.816H67.2415V143.883V143.88ZM67.2415 149.805H70.1743V146.872H67.2415V149.805ZM73.1102 143.88H70.1774V146.813H73.1102V155.67H76.043V141H73.1102V143.877V143.88ZM84.0641 141.056V152.79H81.1313V141.056H78.1985V155.726H87V141.056H84.0672H84.0641Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1358_1488)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.9287,
    y: 140.979,
    width: 59.0898,
    height: 14.791,
    fill: "#E6D113"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.72852,
    width: 4,
    height: 164,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4.72852,
    width: 101,
    height: 5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1358_1488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 175,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLocker);
export default __webpack_public_path__ + "static/media/YellowLocker.6ac207219bf23b25895605a810d38cda.svg";
export { ForwardRef as ReactComponent };